import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../utils/helpers/model.helper';

export const PURCHASE_INFO_SCHEMA = Object.freeze({
  IS_PURCHASABLE: true,
  PAYWALL_CTA: '',
  ENCRYPTED_ACCOUNT_ID: '',
});
const RECORD = generateSchema(PURCHASE_INFO_SCHEMA);
const KEYS: any = generateKeys(PURCHASE_INFO_SCHEMA);

export class PurchaseInfo extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get isPurchasable(): boolean {
    return this.get(KEYS.IS_PURCHASABLE);
  }

  get paywallCta(): string {
    return this.get(KEYS.PAYWALL_CTA);
  }

  get encryptedAccountId(): string {
    return this.get(KEYS.ENCRYPTED_ACCOUNT_ID);
  }
}
